export default __webpack_public_path__ + "static/media/feature2_4.0530d288.png";